import qingfeng_android_qrc from '../assets/imgs/晴风-安卓-qrc.png';
import qingfeng_apple_qrc from '../assets/imgs/晴风-苹果-qrc.png';
import guangqi_android_qrc from '../assets/imgs/光启-安卓-qrc.png';
import guangqi_apple_qrc from '../assets/imgs/光启-苹果-qrc.png';

const HomeBannerConfig = [
    {
        title: '晴风预报-伪装成天气的保密聊天软件',
        text: '收到提示晴风预报版本更新？其实是TA给你来消息了',
        android_qrc: qingfeng_android_qrc,
        apple_qrc: qingfeng_apple_qrc,
        tips: '如存在安装问题，可移步各大应用市场搜索[晴风预报]进行下载安装!输入0000激活隐秘聊天！',
        download_apple:
            'https://apps.apple.com/cn/app/%E6%99%B4%E9%A3%8E%E9%A2%84%E6%8A%A5/id6745515276',
        download_android:
            'https://ml.zhuoruiapp.com/storage/1.1.0_202507282048_qfyb_gw.apk',
    },
    {
        title: '光启学词-伪装成单词的保密聊天软件',
        text: '收到提示背单词消息提醒？其实是TA给你来消息了',
        android_qrc: guangqi_android_qrc,
        apple_qrc: guangqi_apple_qrc,
        tips: '如存在安装问题，可移步各大应用市场搜索[光启学词]进行下载安装!输入0000激活隐秘聊天！',
        download_apple:
            'https://apps.apple.com/cn/app/%E5%85%89%E5%90%AF%E5%AD%A6%E8%AF%8D/id6748822385',
        download_android:
            'https://ml.zhuoruiapp.com/storage/1.0.1_202508081052_xcz_gw.apk',
    },
];

const helpConfigs = [
    {
        title: <h1>晴风预报是什么？</h1>,
        des: (
            <p>
                晴风预报是一款安全稳定的强隐私陌生人社交聊天软件，可以随时随地收发信息，支持与好友音视频通话、一对一单聊，多人群聊，具有保护用户隐私安全的特色功能（截屏提醒、账号销毁等特色功能）。
                晴风预报致力于用户社交信息安全加密，让用户真正体验到私密空间社交，不获取任何与软件使用无关的用户个人信息，不对任何聊天记录收集私密存储。
                注册体验即生成私钥，开启端与端加密通信，防破解，防篡改，防窃听，防监控，为你解决通信风险，让您的聊天更加安全稳定。
            </p>
        ),
    },
    {
        title: <h1>怎么添加好友？</h1>,
        des: (
            <p>
                一、搜索添加
                <br />
                <br />
                在聊天界面，点击右上角【+】的图标，选择【加好友/群】，通过搜索晴风预报版号、昵称、手机号、标签添加好友。
                <br />
                二、扫码添加
                <br />
                <br />
                在聊天界面，点击右上角【+】的图标，选择【扫一扫】，扫描对方的二维码名片即可添加，也可以将自己的二维码名片通过短信、微信、QQ分享出去，让好友扫码添加你。
                <br />
                三、附近人添加
                <br />
                <br />
                在发现界面【附近人】列表可以对感兴趣的陌生人发消息，或请求添加为好友。
            </p>
        ),
    },
    {
        title: <h1>如何登录晴风预报的Web版？</h1>,
        des: (
            <p>
                一、登录晴风预报网页版
                <br />
                <br />
                使用浏览器访问https://web.haiouchat.com/，会出现网页版登录二维码，用手机上的晴风预报APP扫描该二维码，在弹出的页面中点击【登录】，即可在Web端使用晴风预报。
                若扫描二维码无反应，先在晴风预报APP的【聊天】界面顶部查看是否有Web端已登录提示，如果有，先点击【退出web端】，然后刷新网页上的二维码，再次扫描。
                若还是不能登录，先检查一下网络连接是否正常，电脑时间是否为当地正常时间，如果均没有问题，按F5刷新，或者换个浏览器再试试
                <br />
                二、退出晴风预报网页版
                <br />
                <br />
                点击晴风预报网页版左下角的【退出】按钮，在弹出的操作窗口中点击【确定】退出。也可以点击晴风预报APP上【聊天】界面顶部的Web登录提示，进入登录信息页，点击【退出web端】。
            </p>
        ),
    },
    {
        title: <h1>忘记密码怎么办？</h1>,
        des: (
            <p>
                晴风预报版上的所有密码都是经过加密处理的，且未进行私密储存，一旦密码忘记，不能找回，只能重置。
                <br />
                <br />
                一、未登录状态
                <br />
                <br />
                在账号密码登录界面，点击密码输入框下的【忘记密码】选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入手机号获取验证码,
                重新两次设置新密码即可；第二种：【密保验证】先输入您的账号，再正确回答您设置的密保答案，重新两次设置新密码即可。
                <br />
                <br />
                二、已登录状态
                <br />
                <br />
                在【我的-设置-账号设置-登录密码】进入密码设置界面，点击【忘记旧密码】，选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入正确验证码后即可设置新的密码
                第二种：【密保验证】正确回答您设置的密保答案，重新两次设置新密码即可。
            </p>
        ),
    },
    {
        title: <h1>如何防范网络诈骗？</h1>,
        des: (
            <p>
                1、看到“兼职、刷单、刷分、贷款、彩票、代理、返现、中奖、福利、兑换、手续费、保证金”等字眼时，一定要提高警惕。
                <br />
                2、不熟悉的人发的链接不要轻易点开，不熟悉的人发的二维码不要轻易扫描；
                <br />
                3、不要将自己的社交账号信息、购物支付账号信息、银行账户信息、付款码、收到的验证码，发送给不熟悉的人。
                <br />
                4、要求先转账、先付款、先充值、先交手续费、先垫付本金再提供相应服务的，一定要提高警惕。
                <br />
                5、声称某公司、某平台内部工作人员的，绝对不要轻信，请先联系其官方人员确认。
                <br />
                6、自称是好友、亲人、领导等要求借款或缴纳钱款的，最好当面与其本人确认，不要贸然转账汇款。
                <br />
                7、声称某网店、公司或网站客服，说误操作、订单有问题、账号被冻结的，绝对不要理会。
                <br />
                8、声称公、检、法机构人员要求缴纳欠款，绝对不要付款，请先核实确认。
                <br />
                9、不熟悉的人要求添加其他联系方式，到其他平台去聊天时，请慎重考虑。
                <br />
                10、以交友的名义初步建立感情，然后以缺钱等名义让为其汇款的，绝对不要汇款。
            </p>
        ),
    },
    {
        title: <h1>什么是晴风预报密信？</h1>,
        des: (
            <p>
                晴风预报密信是晴风预报系统中的电子邮件特色功能，支持全自动用数字证书加密每一封邮件和自动为每封发出的邮件盖上时间戳。
                晴风预报版密信采用S/MIME国际标准加密电子邮件内容，S/MIME
                基于非对称加密，以保护您的电子邮件免受不必要的访问和篡改攻击。自动配置签名证书和加密证书。您可以放心地发送机密信息,
                可以放心地把所有机密信息和文件信息都加密发送到您的好友电子邮箱中，晴风预报版全程加密发送保障机密信息不被窃取。
            </p>
        ),
    },
    {
        title: <h1>删除聊天记录后还能找回吗？</h1>,
        des: (
            <p>
                晴风预报采用的是端与端加密技术聊天，用户的聊天记录只会保存在用户的手机设备上,
                晴风预报版平台不会进行聊天记录储存，用户一旦撤回或删除后，就将无法恢复找回，请谨慎操作。
            </p>
        ),
    },
    {
        title: <h1>如何举报？</h1>,
        des: (
            <p>
                在好友的资料详情页或群的详情页，点击右上角的三个小点【...】，就可以看到【举报/投诉】的入口,
                上传相关举报资料进行举报，我们收到信息后会尽快核实处理
            </p>
        ),
    },
];

const helpZhaPianConfigs = [
    {
        title: <h1>不骗中国人，只骗外国人算不算犯罪</h1>,
        des: (
            <p>
                “我们都是找境外的人进行诈骗从来不骗中国人......” ---犯罪嫌疑人
                李某
                <br />
                <br />
                近日,广安市公安局前锋区分局,成功打掉一个专门诈骗外国人的电信网络诈骗团伙在湖北襄阳抓获犯罪嫌疑人10名现场查获手机40部,
                电话卡100张，电脑12台而犯罪嫌疑人之一的李某在被审讯时却“语出惊人”，称他们“从来不骗中国人”。
                言归正传，虽然该团伙只针对外国人作案，但诈骗终究是诈骗，无论对象是谁，都是违法犯罪。
            </p>
        ),
    },
    {
        title: <h1>FaceTime来电，接还是不接？</h1>,
        des: (
            <p>
                FaceTime是苹果公司iOS和macOS内置的一款通话软件在两个装有FaceTime的设备之间实现通话如果通话双方均装有FaceTime在知道对方苹果
                ID
                的情况下便可点对点拨打通话。但就是这样的通讯软件在诈骗分子利用下成为了新的诈骗“工具”。
                <br />
                <br />
                “熊猫反诈”温馨提醒
                <br />
                近期诈骗分子频繁通过苹果FaceTime通话实施诈骗，请广大群众不要随意接听，遇到时一定要果断挂断。另切记，凡是提及转账到指定或安全账户的都是诈骗！
            </p>
        ),
    },
    {
        title: <h1>帅气又多金，部队“军官”爱上我</h1>,
        des: (
            <p>
                中国军人忠诚可靠，值得信赖但一些诈骗分子却利用人民群众的信任冒充军人骗取感情钱财让人气愤！
                <br />
                <br />
                “熊猫反诈”温馨提醒
                <br />
                记住！谈钱的人不爱你，爱你的人不谈钱，天上不会掉馅饼，更不会掉下“兵哥哥”！再次提醒广大群众朋友，不要被网络上的虚情假意冲昏了头脑，不要被突然来到的低投入高回报所诱惑，更不要轻易向陌生人账户汇款！
            </p>
        ),
    },
    {
        title: <h1>权威发布!五大高发电信网络诈骗案件</h1>,
        des: (
            <p>
                近年来，公安部认真贯彻落实习近平总书记重要指示精神和党中央决策部署，组织指挥全国公安机关向电信网络诈骗犯罪活动发起凌厉攻势，有效遏制了电信网络诈骗案件快速上升势头。
                今日，公安部公布五类高发电信网络诈骗案件，进一步提升广大群众识骗防骗能力水平，有力震慑违法犯罪分子。
            </p>
        ),
    },
];

export {helpConfigs, helpZhaPianConfigs, HomeBannerConfig};
